import { call } from 'redux-saga/effects'
import { browserName, browserVersion, osName, osVersion } from 'react-device-detect'
import { submitToApi } from 'awsApi'
import { URL } from './endpoints'

export function* postAnalytics({ click, to }) {
    try {
        const { supplierId } = JSON.parse(localStorage.getItem('supplier') || '{}')
        const { username } = JSON.parse(localStorage.getItem('cognitoUser'))

        yield call(() => {
            submitToApi({
                body: { click, to, device: `SUPPLIER | ${osName} | ${osVersion} | ${browserName} | ${browserVersion}` },
                method: 'POST',
                path: URL.ANALYTICS.V3_ANALYTICS_SUPPLIER_CREATE,
                query: { supplierId, managerId: username },
                url: URL.ANALYTICS.BASE,
            })
        })
    } catch (error) {
        console.log('Post Analytics error:', error)
    }
}
